import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/el";
import Header from "../../components/Header";
import ResidentsTable from "../../components/ResidentsTable";
import { useGetSummaryQuery } from "../../services/resident.service";

const MONTH_FORMAT = "YYYY-MM";

// Monthly residents table; the month lives in the URL (?month=YYYY-MM) so it can be shared.
const Residents = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = dayjs(searchParams.get("month"), MONTH_FORMAT);
  const month = searchParams.get("month") && param.isValid() ? param.startOf("month") : dayjs().startOf("month");
  const isCurrentMonth = month.isSame(dayjs(), "month");

  const { data, isFetching, isError } = useGetSummaryQuery(month.format(MONTH_FORMAT));

  const setMonth = (value) => {
    if (value && value.isValid()) {
      setSearchParams({ month: value.format(MONTH_FORMAT) });
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Ειδικευόμενοι" subtitle="Εφημερίες και χειρουργεία του μήνα ανά ειδικευόμενο" />

      <Box display="flex" flexWrap="wrap" alignItems="center" gap="0.5rem" mt="1.5rem">
        <Tooltip title="Προηγούμενος μήνας">
          <IconButton onClick={() => setMonth(month.subtract(1, "month"))}>
            <ChevronLeft />
          </IconButton>
        </Tooltip>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="el">
          <DatePicker
            views={["year", "month"]}
            openTo="month"
            format="MMMM YYYY"
            value={month}
            onChange={setMonth}
            slotProps={{ textField: { size: "small", sx: { width: 220 } } }}
          />
        </LocalizationProvider>
        <Tooltip title="Επόμενος μήνας">
          <IconButton onClick={() => setMonth(month.add(1, "month"))}>
            <ChevronRight />
          </IconButton>
        </Tooltip>
        {!isCurrentMonth && (
          <Button variant="outlined" size="small" onClick={() => setSearchParams({})}>
            Τρέχων μήνας
          </Button>
        )}
      </Box>

      <ResidentsTable data={data} isLoading={isFetching} isError={isError} />
    </Box>
  );
};

export default Residents;
